import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, computed, makeObservable, observable, runInAction, set } from "mobx";
import { humanFileSize } from "../utils/fileSize.js";
import { basename, dirname } from "../utils/path.js";
class UploadItem {
    cid;
    name;
    node;
    percent;
    loaded;
    size;
    relativePath = null;
    previewSrc = "";
    deny;
    get readableLoaded() {
        return humanFileSize(this.loaded);
    }
    get readableSize() {
        return humanFileSize(this.size);
    }
    get relativePathBasename() {
        return this.relativePath ? basename(dirname(this.relativePath)) : this.node.title;
    }
    get icon() {
        return this.relativePath ? "folder" : this.node.title;
    }
    constructor(upload){
        makeObservable(this);
        runInAction(()=>set(this, upload));
    }
    setter(callback) {
        callback(this);
    }
    toJSON() {
        return {
            cid: this.cid,
            name: this.name,
            node: this.node.toJSON(),
            percent: this.percent,
            loaded: this.loaded,
            size: this.size,
            relativePath: this.relativePath,
            previewSrc: this.previewSrc,
            deny: this.deny
        };
    }
}
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], UploadItem.prototype, "cid", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", String)
], UploadItem.prototype, "name", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof FolderNode === "undefined" ? Object : FolderNode)
], UploadItem.prototype, "node", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], UploadItem.prototype, "percent", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], UploadItem.prototype, "loaded", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Number)
], UploadItem.prototype, "size", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], UploadItem.prototype, "relativePath", void 0);
_ts_decorate([
    observable
], UploadItem.prototype, "previewSrc", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", Object)
], UploadItem.prototype, "deny", void 0);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], UploadItem.prototype, "readableLoaded", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], UploadItem.prototype, "readableSize", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], UploadItem.prototype, "relativePathBasename", null);
_ts_decorate([
    computed,
    _ts_metadata("design:type", void 0),
    _ts_metadata("design:paramtypes", [])
], UploadItem.prototype, "icon", null);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Function
    ]),
    _ts_metadata("design:returntype", void 0)
], UploadItem.prototype, "setter", null);
export { UploadItem };
